export const hiCore = {
  common: {
    save: 'सहेजें',
    cancel: 'रद्द करें',
    apply: 'लागू करें',
    close: 'बंद करें',
    back: 'वापस',
    verify: 'सत्यापित करें',
    loading: 'लोड हो रहा है...',
    retry: 'पुनः प्रयास करें',
    or: 'या',
    today: 'आज',
    doctor: 'चिकित्सक',
    clinic: 'क्लिनिक',
    unknown: 'अज्ञात',
    copy: 'कॉपी',
    copied: 'कॉपी हो गया!',
    add: 'जोड़ें',
  },
  language: {
    label: 'इंटरफ़ेस भाषा',
    english: 'English',
    indonesian: 'Bahasa Indonesia',
  },
  header: {
    sessions: 'सत्र',
    back: 'सत्रों पर वापस',
    logout: 'लॉग आउट',
    history: 'इतिहास',
    chatWithEhr: 'EHR से चैट करें',
    dashboard: 'डैशबोर्ड',
    clinic: 'क्लिनिक',
    aiUsage: 'AI उपयोग',
    profile: 'प्रोफ़ाइल',
    endSession: 'सत्र समाप्त करें',
    stopViewing: 'देखना बंद करें',
    actingAs: '{name} · {clinic} के रूप में कार्यरत',
    impersonation: '(प्रतिरूपण)',
    viewingClinic: 'देख रहे हैं: {clinic}',
    readOnly: '(केवल पढ़ने योग्य)',
    logoAlt: 'AIGP Health लोगो',
    pages: {
      consultTitle: 'रोगी परामर्श',
      consultSubtitle: 'AI स्क्राइब और नैदानिक दस्तावेज़',
      dashboardTitle: 'चिकित्सक डैशबोर्ड',
      dashboardSubtitle: 'वापस स्वागत है, {name}',
      sessionsTitle: 'सत्र प्रबंधित करें',
      sessionsSubtitle: 'रोगी परामर्श सत्र बनाएँ और प्रबंधित करें',
      meetingTitle: 'ऑनलाइन परामर्श',
      meetingSubtitle: 'रोगी परामर्श के लिए वर्चुअल मीटिंग कक्ष',
      profileTitle: 'मेरी प्रोफ़ाइल',
      profileSubtitle: 'अपनी खाता जानकारी और प्राथमिकताएँ प्रबंधित करें',
      clinicProfileTitle: 'क्लिनिक प्रोफ़ाइल',
      clinicProfileSubtitle: 'क्लिनिक जानकारी और सेटिंग्स प्रबंधित करें',
      clinicAdminTitle: 'क्लिनिक प्रशासन',
      clinicAdminSubtitle: 'स्वागत है, {name}',
      adminTitle: 'प्रशासन डैशबोर्ड',
      adminSubtitle: 'वापस स्वागत है, {name}',
      superAdminTitle: 'सुपर एडमिन डैशबोर्ड',
      superAdminSubtitle: 'स्वागत है, {name}',
      aiUsageTitle: 'AI उपयोग',
      aiUsageSubtitle: 'AI प्रवाहों में टोकन खपत, लागत और विलंबता',
      defaultTitle: 'AIGP Health',
      defaultSubtitle: 'चिकित्सा परामर्श प्लेटफ़ॉर्म',
      adminFallback: 'प्रशासक',
      superAdminFallback: 'सुपर एडमिन',
    },
  },
  auth: {
    welcomeBack: 'वापस स्वागत है',
    loginSubtitle: 'अपने AIGP Health कार्यक्षेत्र में जारी रखने के लिए साइन इन करें।',
    signInEyebrow: 'साइन इन',
    signInTitle: 'अपने खाते में साइन इन करें',
    email: 'ईमेल पता',
    emailPlaceholder: 'you@clinic.com',
    password: 'पासवर्ड',
    passwordPlaceholder: 'अपना पासवर्ड दर्ज करें',
    showPassword: 'पासवर्ड दिखाएँ',
    hidePassword: 'पासवर्ड छिपाएँ',
    signIn: 'साइन इन',
    signInGoogle: 'Google से साइन इन करें',
    forgotPassword: 'पासवर्ड भूल गए?',
    createAccount: 'खाता बनाएँ',
    verifyEyebrow: 'पहचान सत्यापित करें',
    enterCode: 'अपना कोड दर्ज करें',
    otpHint: 'WhatsApp के माध्यम से आपके पंजीकृत फ़ोन पर भेजा गया 6-अंकीय कोड दर्ज करें।',
    loginOtpAria: 'लॉगिन सत्यापन कोड',
    resendIn: '{seconds} सेकंड में कोड पुनः भेजें',
    requestNewCode: 'नया कोड माँगें',
    secureEyebrow: 'अपना खाता सुरक्षित करें',
    mfaTitle: 'दो-कारक प्रमाणीकरण सेट करें',
    mfaHint: 'WhatsApp पर एकबारगी कोड प्राप्त करने के लिए फ़ोन नंबर जोड़ें।',
    phone: 'फ़ोन नंबर',
    phonePlaceholder: 'फ़ोन नंबर दर्ज करें',
    sendCode: 'कोड भेजें',
    resendCode: 'कोड पुनः भेजें',
    mfaOtpAria: 'MFA सेटअप सत्यापन कोड',
    invalidEmail: 'कृपया एक मान्य ईमेल पता दर्ज करें।',
    enterPassword: 'कृपया अपना पासवर्ड दर्ज करें।',
    emailUnverified: 'आपका ईमेल अभी सत्यापित नहीं है। MFA सेट करने से पहले इसे सत्यापित करें।',
    authError: 'प्रमाणीकरण त्रुटि। कृपया सहायता से संपर्क करें।',
    badCredentials: 'ईमेल या पासवर्ड गलत है। कृपया पुनः प्रयास करें।',
    unableToSignIn: 'साइन इन नहीं हो सका। कृपया पुनः प्रयास करें।',
    enterFullCode: 'कृपया पूरा 6-अंकीय कोड दर्ज करें।',
    sessionExpired: 'सत्र समाप्त हो गया। कृपया फिर से साइन इन करें।',
    invalidCode: 'अमान्य कोड। कृपया पुनः प्रयास करें।',
    couldNotResend: 'कोड पुनः नहीं भेजा जा सका।',
    startOver: 'फिर से शुरू करें',
    attemptRemaining: '{count} प्रयास शेष',
    attemptsRemaining: '{count} प्रयास शेष',
    invalidPhone: 'कृपया एक मान्य फ़ोन नंबर दर्ज करें।',
    couldNotSend: 'कोड नहीं भेजा जा सका।',
    googleUnexpected: 'Google साइन-इन से अप्रत्याशित प्रतिक्रिया।',
    googleFailed: 'Google साइन-इन विफल रहा।',
    routingFailed: 'लॉगिन पूरा हुआ लेकिन रूटिंग विफल रही। कृपया पुनः प्रयास करें।',
    shellDefaultTitle: 'AIGP Health में आपका स्वागत है',
    shellDefaultSubtitle: 'रुमेटोलॉजी और सामान्य चिकित्सा के लिए साक्ष्य-आधारित नैदानिक निर्णय सहायता।',
    trustHipaa: 'HIPAA-अनुकूल डेटा हैंडलिंग',
    trustEncrypted: 'पारगमन और संग्रह दोनों में एन्क्रिप्टेड',
    trustEvidence: 'चिकित्सक-सत्यापित साक्ष्य',
    registrationPhases: 'पंजीकरण चरण',
    trustAria: 'विश्वास और सुरक्षा',
    progress: 'प्रगति',
    disclaimerTitle: 'अस्वीकरण',
    disclaimerBody:
      'AIGP Health और उसका AI प्लेटफ़ॉर्म "Anzu" योग्य स्वास्थ्य पेशेवरों के नैदानिक निर्णय की सहायता के लिए है — उसका विकल्प नहीं। सभी नैदानिक निर्णय लाइसेंसशुदा चिकित्सक द्वारा लिए जाने चाहिए। Anzu द्वारा दी गई जानकारी पेशेवर चिकित्सा सलाह, निदान या उपचार का विकल्प नहीं है।',
    iUnderstand: 'मैं समझ गया/गई',
  },
  forgot: {
    title: 'अपना पासवर्ड रीसेट करें',
    subtitle: 'हम आपको आपके खाते में वापस आने में मदद करेंगे।',
    eyebrow: 'खाता पुनर्प्राप्ति',
    stepEmail: 'पासवर्ड रीसेट करें',
    stepOtp: 'कोड सत्यापित करें',
    stepReset: 'नया पासवर्ड सेट करें',
    hintEmail: 'अपना ईमेल दर्ज करें और हम रीसेट कोड भेजेंगे।',
    hintOtp: 'आपके फ़ोन पर भेजा गया 6-अंकीय कोड दर्ज करें।',
    hintReset: 'अपने ईमेल से टोकन दर्ज करें और नया पासवर्ड चुनें।',
    sendResetCode: 'रीसेट कोड भेजें',
    otpAria: 'पासवर्ड रीसेट कोड',
    resetToken: 'रीसेट टोकन',
    tokenPlaceholder: 'अपने ईमेल से टोकन पेस्ट करें',
    newPassword: 'नया पासवर्ड',
    newPasswordPlaceholder: 'नया पासवर्ड दर्ज करें',
    confirmPassword: 'नए पासवर्ड की पुष्टि करें',
    confirmPlaceholder: 'नया पासवर्ड दोबारा दर्ज करें',
    resetPassword: 'पासवर्ड रीसेट करें',
    backToSignIn: 'साइन इन पर वापस जाएँ',
    codeSent: 'रीसेट कोड आपके फ़ोन पर भेज दिया गया है।',
    codeResent: 'एक नया रीसेट कोड भेज दिया गया है।',
    sendFailed: 'कोड नहीं भेजा जा सका। कृपया पुनः प्रयास करें।',
    resendFailed: 'कोड पुनः नहीं भेजा जा सका।',
    enterFullCode: 'कृपया पूरा 6-अंकीय कोड दर्ज करें।',
    tokenSent: 'रीसेट टोकन आपके ईमेल पर भेजा गया। इसे नीचे नए पासवर्ड के साथ दर्ज करें।',
    invalidCode: 'अमान्य कोड। कृपया पुनः प्रयास करें।',
    enterToken: 'कृपया अपने ईमेल से रीसेट टोकन दर्ज करें।',
    passwordRequirements: 'पासवर्ड आवश्यकताओं को पूरा नहीं करता।',
    passwordsMismatch: 'पासवर्ड मेल नहीं खाते।',
    resetSuccess: 'पासवर्ड सफलतापूर्वक रीसेट हो गया। साइन इन पर भेजा जा रहा है…',
    resetFailed: 'पासवर्ड रीसेट नहीं हो सका। कृपया पुनः प्रयास करें।',
  },
  dashboard: {
    approvalTitle: 'क्लिनिक अनुमोदन लंबित',
    approvalBody: 'आपका क्लिनिक पंजीकरण वर्तमान में हमारी प्रशासन टीम द्वारा समीक्षाधीन है।',
    approvalAccess: 'क्लिनिक अनुमोदित होने के बाद आप चिकित्सक पोर्टल तक पहुँच सकेंगे।',
    approvalHelp: 'प्रश्न होने पर अपने क्लिनिक व्यवस्थापक या सहायता से संपर्क करें।',
    welcome: 'नमस्ते, डॉ. {name}!',
    welcomeBody: 'अपने रोगी सत्र प्रबंधित करने और उत्तम देखभाल देने के लिए तैयार',
    whatToDo: 'आप क्या करना चाहेंगे?',
    manageSessions: 'सत्र प्रबंधित करें',
    manageSessionsBody: 'रोगी परामर्श सत्र बनाएँ, संपादित करें और व्यवस्थित करें',
    manageFeature1: 'नए परामर्श निर्धारित करें',
    manageFeature2: 'रोगी जानकारी अपडेट करें',
    manageFeature3: 'अपॉइंटमेंट विवरण प्रबंधित करें',
    clinicAdmin: 'क्लिनिक प्रशासन',
    clinicAdminBody: 'उपयोगकर्ता, सदस्यताएँ और क्लिनिक अवलोकन प्रबंधित करें',
    clinicFeature1: 'अवलोकन और विश्लेषण',
    clinicFeature2: 'उपयोगकर्ता प्रबंधन',
    clinicFeature3: 'सदस्यता प्रबंधन',
  },
  usage: {
    loadingChip: 'सत्र…',
    loadingBanner: 'आपका सत्र उपयोग लोड हो रहा है…',
    loadingTitle: 'सत्र उपयोग लोड हो रहा है',
    errorChip: 'सत्र —',
    errorBanner: 'आपका सत्र उपयोग लोड नहीं हो सका। {error}',
    loadFailed: 'सत्र उपयोग लोड नहीं हो सका',
    unlimitedTitle: 'असीमित सत्र — कोई मासिक सीमा नहीं',
    usedTitle: 'इस माह {used} में से {limit} सत्र उपयोग हुए',
    unlimitedChip: 'सत्र ∞',
    sessionsLabel: 'सत्र',
    unlimitedBanner: 'असीमित — कोई मासिक सीमा नहीं।',
    usedThisPeriod: 'आपने इस अवधि में {used} सत्र उपयोग किया है।',
    usedThisPeriodPlural: 'आपने इस अवधि में {used} सत्र उपयोग किए हैं।',
    reachedLimit: 'आप अपनी मासिक सत्र सीमा पर पहुँच गए हैं ({used}/{limit})। अगली अवधि में सत्र रीसेट होंगे।',
    oneLeft: 'इस माह 1 सत्र शेष। {used}/{limit} उपयोग।',
    manyLeft: 'इस माह {remaining} सत्र शेष। {used}/{limit} उपयोग।',
  },
  inactivity: {
    title: 'सत्र जल्द समाप्त होगा',
    body: 'निष्क्रियता के कारण आपका सत्र इतने समय में समाप्त हो जाएगा:',
    continueQuestion: 'क्या आप अपना सत्र जारी रखना चाहेंगे?',
    logoutNow: 'अभी लॉग आउट करें',
    continueSession: 'सत्र जारी रखें',
  },
  subscription: {
    title: 'सदस्यता लंबित',
    bodyNamed: 'डॉ. {name}, आपका खाता तैयार है, लेकिन आपके क्लिनिक की सक्रिय सदस्यता अभी नहीं है।',
    bodyUnnamed: 'आपका खाता तैयार है, लेकिन आपके क्लिनिक की सक्रिय सदस्यता अभी नहीं है।',
    access: 'क्लिनिक किसी प्लान पर आने के बाद आप चिकित्सक पोर्टल तक पहुँच सकेंगे।',
    help: 'केवल क्लिनिक व्यवस्थापक सदस्यता सक्रिय कर सकता है। उसके बाद नीचे फिर जाँचें या फिर से साइन इन करें।',
    checking: 'जाँच हो रही है…',
    checkAgain: 'फिर जाँचें',
    stillPending: 'आपके क्लिनिक की अभी भी सक्रिय सदस्यता नहीं है। कृपया क्लिनिक व्यवस्थापक से जाँचें।',
    checkFailed: 'सदस्यता स्थिति जाँची नहीं जा सकी। कृपया थोड़ी देर बाद पुनः प्रयास करें।',
  },
};
